export default __webpack_public_path__ + "static/media/gear.e350f069.svg";